<!--
 * @Author: Latte
 * @Date: 2021-12-02 10:56:10
 * @LAstEditors: Latte
 * @LastEditTime: 2021-12-09 14:27:30
 * @FilePath: \Siui.Cloud.Medical.Web\src\components\FileManagement\File\CategoryDetail.vue
-->
<!-- TODO-->
<template>
  <el-card class="form-container">
    <!--本组件已弃用-->
    <el-form :model="temp" label-width="150px">
      <el-form-item label="显示名称" prop="showName" :rules="required">
        <el-input v-model="temp.showName"></el-input>
      </el-form-item>
      <el-form-item label="俄语版本显示名">
        <el-input v-model="temp.showNameRussian"></el-input>
        <div>俄语版本显示名,海外版必填</div>
      </el-form-item>
      <el-form-item label="排序">
        <el-input-number
          size="small"
          v-model="temp.sort"
          :min="1"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="是否启用" prop="isEnable" :rules="required">
        <el-radio-group v-model="temp.isEnable">
          <el-radio :label="true">是</el-radio>
          <el-radio :label="false">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <!-- <el-form-item label="是否删除">
        <el-radio-group v-model="temp.col4">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item> -->
      <!-- <el-form-item label="描述">
        <el-input v-model="temp.col5"></el-input>
      </el-form-item> -->
      -->
      <el-form-item>
        <el-button type="primary" size="small">提交</el-button>
        <el-button size="small" @click.stop="$router.go(-1)">返回</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
export default {
  data() {
    return {
      required: [{ required: true, message: "必填项", trigger: "blur" }], // 校验规则
      temp: { col2: 1},
      options: Object.freeze([
        { label: "无上级分类", value: 0 },
        { label: "超声", value: 1 },
        { label: "X-Ray", value: 2 },
        { label: "I-Bus", value: 3 },
      ]),
    };
  },
  created() {
    this.temp = this.$route.query.list;
    console.log(this.temp);
  },
};
</script>

<style lang="scss" scoped>
</style>